import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { useAuth } from "../contexts/AuthContext";
import { RoleEnum } from "../types";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  // Show loading state while checking authentication
  if (isLoading) {
    return null;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const StoreManagerRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { role, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (role !== RoleEnum.STORE_MANAGER) {
    return <Navigate to={ROUTES.ERROR_404} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
export { StoreManagerRoute };
